// 휴가 시간 값 두 줄 표기(2026-10-22) — 서버 hours_text("183시간(22.88일)")를
//   183시간
//   (22.88일)   ← 회색 작은 글씨
// 로 나눠 보여준다. 숫자는 다시 계산하지 않는다(정본은 서버 leave.hours_text).
// 휴가신청서 미리보기·PDF·상세(LeaveRequestPreview)와 작성 화면 요약 박스가 함께 쓴다.
import React from "react";
import "./LeaveRequestPreview.css";

const PATTERN = /^(.*?)\s*\(([^()]*)\)\s*$/;

export function splitHoursText(text) {
  const m = PATTERN.exec(String(text ?? ""));
  return m ? { hours: m[1], days: `(${m[2]})` } : { hours: text ?? "", days: "" };
}

export default function HoursText({ text, strong = false, align = "center" }) {
  if (!text) return "-";
  const { hours, days } = splitHoursText(text);
  return (
    <span className={`lr-hours lr-hours-${align}`}>
      <span className={strong ? "lr-hours-main lr-strong" : "lr-hours-main"}>{hours}</span>
      {days && <span className="lr-hours-days">{days}</span>}
    </span>
  );
}
